"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AppStore from "@/assets/images/common/AppStore.png";
import GooglePlay from "@/assets/images/common/GooglePlay.png";
import { toast } from "@/components/pop-ui/pop-toast";
import { QuickChatWrapper } from "@/components/pop-ui/quick-chat-button";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useIsMobile } from "@/hooks/use-mobile";
import { LanguageSwitcherInFooter } from "@/lib/i18n/language-switcher";
import LocaleLink from "@/lib/i18n/locale-link";
import { getCurrentLanguageInClient } from "@/lib/utils.client";
import { trackSubscription } from "@/track/gtm";
import { CMSLink, CMSText } from "../cms/components/cms-items";
import { getTranslatedText } from "../cms/utils.server";
import { communityInfo, contactInfo, copyrightInfo, creditCardList, mediaList } from "./footer.config";
function MobileSocialBar(t0) {
  const $ = _c(7);
  const {
    socialMedia
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== socialMedia?.platforms) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const enabledPlatforms = socialMedia?.platforms?.filter(_temp) || [];
      if (enabledPlatforms.length === 0) {
        t3 = null;
        break bb0;
      }
      const filteredMediaList = mediaList.filter(item => enabledPlatforms.some(platform_0 => platform_0.platform.toUpperCase() === item.platform.toUpperCase()));
      if (filteredMediaList.length === 0) {
        t3 = null;
        break bb0;
      }
      t1 = "flex items-center justify-center gap-2 py-4";
      t2 = filteredMediaList.map(item_0 => {
        const platformData = enabledPlatforms.find(platform_1 => platform_1.platform.toUpperCase() === item_0.platform.toUpperCase());
        const url = platformData?.url || "#";
        const isExternalUrl = url.startsWith("http://") || url.startsWith("https://");
        if (isExternalUrl) {
          return <a key={item_0.platform} href={url} target="_blank" rel="noopener noreferrer"><Image src={item_0.src} alt="social" width={28} height={28} className="brightness-0 invert" style={{
              width: "7.47vw",
              height: "7.47vw"
            }} unoptimized={true} /></a>;
        }
        return <LocaleLink key={item_0.platform} href={url as any} target="_blank" rel="noopener noreferrer"><Image src={item_0.src} alt="social" width={28} height={28} className="brightness-0 invert" style={{
            width: "7.47vw",
            height: "7.47vw"
          }} unoptimized={true} /></LocaleLink>;
      });
    }
    $[0] = socialMedia?.platforms;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp(platform) {
  return platform.enabled;
}
function _MobileDownloadBar() {
  return <div className="mb-6 flex items-center justify-center gap-2">
			<button type="button" className="flex h-[52px] w-[139px] cursor-pointer items-center justify-center p-0 transition-shadow hover:shadow-lg" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.popmart.global", "_blank")}>
				<Image src={GooglePlay} alt="Google Play" width={152} height={44} unoptimized />
			</button>
			<button type="button" className="flex h-[52px] w-[139px] cursor-pointer items-center justify-center p-0 transition-shadow hover:shadow-lg" onClick={() => window.open("https://apps.apple.com/us/app/pop-mart/id1594346256", "_blank")}>
				<Image src={AppStore} alt="App Store" width={152} height={44} unoptimized />
			</button>
		</div>;
}
function MobileFooterSection(t0) {
  const $ = _c(23);
  const {
    title,
    buttons: t1
  } = t0;
  const buttons = t1 === undefined ? [] : t1;
  const [open, setOpen] = useState(false);
  const lang = getCurrentLanguageInClient();
  const t2 = "border-b border-[#222]";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: "2.93vw"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontSize: "2.93vw"
    };
    t5 = () => setOpen(_temp2);
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  let t6;
  if ($[3] !== title) {
    t6 = <span>{title}</span>;
    $[3] = title;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      fontSize: "2.93vw"
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = open ? "\u2212" : "+";
  let t9;
  if ($[6] !== t8) {
    t9 = <span className="text-2xl transition-all duration-300 ease-in-out select-none" style={t7}>{t8}</span>;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t6 || $[9] !== t9) {
    t10 = <button type="button" className="flex w-full items-center justify-between py-4 text-base font-bold text-white" style={t4} onClick={t5}>{t6}{t9}</button>;
    $[8] = t6;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = "overflow-hidden transition-all duration-300 ease-in-out";
  const t12 = open ? "500px" : "0px";
  const t13 = open ? 1 : 0;
  let t14;
  if ($[11] !== t12 || $[12] !== t13) {
    t14 = {
      maxHeight: t12,
      opacity: t13
    };
    $[11] = t12;
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  const t15 = "pb-4";
  const t16 = buttons.map((item, index) => {
    const buttonData = item.button || item;
    const uniqueKey = item.id || `${index}-${buttonData.text?.en || buttonData.text || "button"}`;
    return <CMSLink key={uniqueKey} link={buttonData.link}><div className="text-footer-gray py-2 pl-2 text-sm" style={{
        fontSize: "2.93vw"
      }}>{" "}<CMSText text={getTranslatedText(lang, buttonData.text)} />{" "}</div></CMSLink>;
  });
  let t17;
  if ($[14] !== t16) {
    t17 = <div className={t15}>{t16}</div>;
    $[14] = t16;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  let t18;
  if ($[16] !== t14 || $[17] !== t17) {
    t18 = <div className={t11} style={t14}>{t17}</div>;
    $[16] = t14;
    $[17] = t17;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== t10 || $[20] !== t18 || $[21] !== t3) {
    t19 = <div className={t2} style={t3}>{t10}{t18}</div>;
    $[19] = t10;
    $[20] = t18;
    $[21] = t3;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  return t19;
}
function _temp2(v) {
  return !v;
}
interface MobileFooterProps {
  footerSections: any[];
  lang: string;
  area: string;
  socialMedia: Record<string, any>;
  paymentData: Record<string, any>;
  customer: Record<string, any>;
}
export function MobileFooter(t0) {
  const $ = _c(118);
  const {
    footerSections,
    lang,
    socialMedia,
    paymentData,
    customer
  } = t0;
  const {
    t
  } = useTranslation();
  const isMobile = useIsMobile();
  const [email, setEmail] = useState("");
  if (!isMobile) {
    return null;
  }
  let t1;
  if ($[0] !== email || $[1] !== t) {
    t1 = () => {
      if (!email.includes("@")) {
        toast.error(t("footer.subscribe.invalidEmail"));
        trackSubscription({
          status: "failed"
        });
        return;
      }
      (window as any)?.quickChatApi?.setContactProperties({
        email
      });
      toast.success(t("footer.subscribe.success"));
      trackSubscription({
        status: "success"
      });
      setEmail("");
    };
    $[0] = email;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSubscribe = t1;
  let t2;
  if ($[3] !== customer) {
    t2 = () => {
      if (!customer || Object.keys(customer).length === 0 || !customer.email) {
        return "support@popmart.com";
      }
      return customer.email;
    };
    $[3] = customer;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getEmailFromCustomer = t2;
  let t3;
  if ($[5] !== customer || $[6] !== lang) {
    t3 = () => {
      if (!customer || Object.keys(customer).length === 0 || !customer.serviceTime_trans) {
        return "Monday-Sunday 9:00am-18:00pm CST";
      }
      const translatedTime = customer.serviceTime_trans[lang];
      return translatedTime;
    };
    $[5] = customer;
    $[6] = lang;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getServiceTime = t3;
  let t4;
  if ($[8] !== paymentData) {
    t4 = () => {
      if (!paymentData || Object.keys(paymentData).length === 0) {
        return creditCardList;
      }
      if (paymentData.payments && Array.isArray(paymentData.payments) && paymentData.payments.length === 0) {
        return [];
      }
      if (paymentData.payments && Array.isArray(paymentData.payments) && paymentData.payments.length > 0) {
        return creditCardList.filter(card => paymentData.payments.some(p => p.toUpperCase() === card.method.toUpperCase()));
      }
      return [];
    };
    $[8] = paymentData;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getPaymentMethods = t4;
  let t5;
  if ($[10] !== email || $[11] !== footerSections || $[12] !== getEmailFromCustomer || $[13] !== getPaymentMethods || $[14] !== getServiceTime || $[15] !== handleSubscribe || $[16] !== lang || $[17] !== socialMedia || $[18] !== t) {
    const paymentMethodsToShow = getPaymentMethods();
    let t6;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        fontSize: "4.27vw"
      };
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    let t7;
    if ($[21] !== t) {
      t7 = t(communityInfo.title);
      $[21] = t;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    let t8;
    if ($[23] !== t7) {
      t8 = <div className="mb-2 font-['DINPro-Bold'] font-bold text-white" style={t6}>{t7}</div>;
      $[23] = t7;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    let t9;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        fontSize: "2.93vw"
      };
      $[25] = t9;
    } else {
      t9 = $[25];
    }
    let t10;
    if ($[26] !== t) {
      t10 = t(communityInfo.description);
      $[26] = t;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    let t11;
    if ($[28] !== t10) {
      t11 = <div className="text-footer-gray mb-3 font-['DINPro-Regular']" style={t9}>{t10}</div>;
      $[28] = t10;
      $[29] = t11;
    } else {
      t11 = $[29];
    }
    let t12;
    if ($[30] !== t) {
      t12 = t(communityInfo.placeholder);
      $[30] = t;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    let t13;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = {
        fontSize: "2.93vw"
      };
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    let t14;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = e => setEmail(e.target.value);
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    let t15;
    if ($[34] !== email || $[35] !== t12) {
      t15 = <Input placeholder={t12} className="h-[39px] flex-1 rounded-none border-none bg-transparent sm:h-[78px]" style={t13} value={email} onChange={t14} />;
      $[34] = email;
      $[35] = t12;
      $[36] = t15;
    } else {
      t15 = $[36];
    }
    let t16;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = {
        fontFamily: "PingFangSC, PingFang SC",
        fontWeight: 400,
        fontSize: "2.93vw",
        color: "#000000",
        textDecoration: "underline"
      };
      $[37] = t16;
    } else {
      t16 = $[37];
    }
    let t17;
    if ($[38] !== t) {
      t17 = t(communityInfo.signUp);
      $[38] = t;
      $[39] = t17;
    } else {
      t17 = $[39];
    }
    let t18;
    if ($[40] !== handleSubscribe || $[41] !== t17) {
      t18 = <Button variant="link" className="mr-2 bg-transparent p-0" onClick={handleSubscribe} style={t16}>{t17}</Button>;
      $[40] = handleSubscribe;
      $[41] = t17;
      $[42] = t18;
    } else {
      t18 = $[42];
    }
    let t19;
    if ($[43] !== t15 || $[44] !== t18) {
      t19 = <div className="mb-6 flex items-center bg-white">{t15}{t18}</div>;
      $[43] = t15;
      $[44] = t18;
      $[45] = t19;
    } else {
      t19 = $[45];
    }
    let t20;
    if ($[46] !== t11 || $[47] !== t19 || $[48] !== t8) {
      t20 = <div>{t8}{t11}{t19}</div>;
      $[46] = t11;
      $[47] = t19;
      $[48] = t8;
      $[49] = t20;
    } else {
      t20 = $[49];
    }
    let t21;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = {
        fontSize: "4.27vw"
      };
      $[50] = t21;
    } else {
      t21 = $[50];
    }
    let t22;
    if ($[51] !== t) {
      t22 = t(contactInfo.title);
      $[51] = t;
      $[52] = t22;
    } else {
      t22 = $[52];
    }
    let t23;
    if ($[53] !== t22) {
      t23 = <div className="mb-4 font-['DINPro-Bold'] font-bold text-white" style={t21}>{t22}</div>;
      $[53] = t22;
      $[54] = t23;
    } else {
      t23 = $[54];
    }
    let t24;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = {
        fontSize: "2.93vw"
      };
      $[55] = t24;
    } else {
      t24 = $[55];
    }
    let t25;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = {
        fontSize: "2.93vw"
      };
      $[56] = t25;
    } else {
      t25 = $[56];
    }
    let t26;
    if ($[57] !== t) {
      t26 = t(contactInfo.chatButton);
      $[57] = t;
      $[58] = t26;
    } else {
      t26 = $[58];
    }
    let t27;
    if ($[59] !== t26) {
      t27 = <QuickChatWrapper><Button variant="link" size="sm" className="text-footer-gray absolute top-1/2 right-[15px] ml-2 !h-[14px] -translate-y-1/2 bg-transparent p-0 underline hover:text-white" style={t25}>{t26}</Button></QuickChatWrapper>;
      $[59] = t26;
      $[60] = t27;
    } else {
      t27 = $[60];
    }
    let t28;
    if ($[61] !== t) {
      t28 = t(contactInfo.chatTitle);
      $[61] = t;
      $[62] = t28;
    } else {
      t28 = $[62];
    }
    let t29;
    if ($[63] !== t28) {
      t29 = <span className="font-['DINPro-Bold'] font-bold text-white">{t28}</span>;
      $[63] = t28;
      $[64] = t29;
    } else {
      t29 = $[64];
    }
    let t30;
    if ($[65] !== getServiceTime) {
      t30 = getServiceTime();
      $[65] = getServiceTime;
      $[66] = t30;
    } else {
      t30 = $[66];
    }
    let t31;
    if ($[67] !== t30) {
      t31 = <div className="text-footer-gray mt-2 w-[72vw] font-['DINPro-Regular']">{t30}</div>;
      $[67] = t30;
      $[68] = t31;
    } else {
      t31 = $[68];
    }
    let t32;
    if ($[69] !== t27 || $[70] !== t29 || $[71] !== t31) {
      t32 = <div className="border-footer-gray relative mb-2 flex flex-col rounded border p-3" style={t24}>{t27}{t29}{t31}</div>;
      $[69] = t27;
      $[70] = t29;
      $[71] = t31;
      $[72] = t32;
    } else {
      t32 = $[72];
    }
    let t33;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
      t33 = {
        fontSize: "2.93vw"
      };
      $[73] = t33;
    } else {
      t33 = $[73];
    }
    let t34;
    if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
      t34 = {
        fontSize: "2.93vw"
      };
      $[74] = t34;
    } else {
      t34 = $[74];
    }
    let t35;
    if ($[75] !== getEmailFromCustomer || $[76] !== t) {
      t35 = () => {
        navigator.clipboard.writeText(getEmailFromCustomer());
        toast.success(t("footer.subscribe.copySuccess"));
      };
      $[75] = getEmailFromCustomer;
      $[76] = t;
      $[77] = t35;
    } else {
      t35 = $[77];
    }
    let t36;
    if ($[78] !== t) {
      t36 = t(contactInfo.emailButton);
      $[78] = t;
      $[79] = t36;
    } else {
      t36 = $[79];
    }
    let t37;
    if ($[80] !== t35 || $[81] !== t36) {
      t37 = <Button variant="link" size="sm" className="text-footer-gray absolute top-1/2 right-[15px] ml-2 !h-[14px] -translate-y-1/2 bg-transparent p-0 underline hover:text-white" style={t34} onClick={t35}>{t36}</Button>;
      $[80] = t35;
      $[81] = t36;
      $[82] = t37;
    } else {
      t37 = $[82];
    }
    let t38;
    if ($[83] !== t) {
      t38 = t(contactInfo.emailTitle);
      $[83] = t;
      $[84] = t38;
    } else {
      t38 = $[84];
    }
    let t39;
    if ($[85] !== t38) {
      t39 = <span className="font-['DINPro-Bold'] font-bold text-white">{t38}</span>;
      $[85] = t38;
      $[86] = t39;
    } else {
      t39 = $[86];
    }
    let t40;
    if ($[87] !== getEmailFromCustomer) {
      t40 = getEmailFromCustomer();
      $[87] = getEmailFromCustomer;
      $[88] = t40;
    } else {
      t40 = $[88];
    }
    let t41;
    if ($[89] !== t40) {
      t41 = <div className="text-footer-gray mt-2 w-[72vw] font-['DINPro-Regular']">{t40}</div>;
      $[89] = t40;
      $[90] = t41;
    } else {
      t41 = $[90];
    }
    let t42;
    if ($[91] !== t37 || $[92] !== t39 || $[93] !== t41) {
      t42 = <div className="border-footer-gray relative mb-2 flex flex-col rounded border p-3" style={t33}>{t37}{t39}{t41}</div>;
      $[91] = t37;
      $[92] = t39;
      $[93] = t41;
      $[94] = t42;
    } else {
      t42 = $[94];
    }
    let t43;
    if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
      t43 = {
        fontSize: "2.93vw"
      };
      $[95] = t43;
    } else {
      t43 = $[95];
    }
    let t44;
    if ($[96] !== t) {
      t44 = t(contactInfo.helpCenter);
      $[96] = t;
      $[97] = t44;
    } else {
      t44 = $[97];
    }
    let t45;
    if ($[98] !== t44) {
      t45 = <div className="flex justify-center"><Button variant="link" size="sm" className="text-footer-gray mt-2 !h-[14px] bg-transparent p-0 underline hover:text-white" style={t43} asChild={true}><LocaleLink href={"/help/faqs" as any}>{t44}</LocaleLink></Button></div>;
      $[98] = t44;
      $[99] = t45;
    } else {
      t45 = $[99];
    }
    let t46;
    if ($[100] !== t23 || $[101] !== t32 || $[102] !== t42 || $[103] !== t45) {
      t46 = <div className="mb-6">{t23}{t32}{t42}{t45}</div>;
      $[100] = t23;
      $[101] = t32;
      $[102] = t42;
      $[103] = t45;
      $[104] = t46;
    } else {
      t46 = $[104];
    }
    let t47;
    if ($[105] !== socialMedia) {
      t47 = <MobileSocialBar socialMedia={socialMedia} />;
      $[105] = socialMedia;
      $[106] = t47;
    } else {
      t47 = $[106];
    }
    let t48;
    if ($[107] !== footerSections || $[108] !== lang || $[109] !== t) {
      let t49;
      if ($[111] !== lang || $[112] !== t) {
        t49 = section => {
          const sectionTitle = getTranslatedText(lang, section.title_trans) || t("footer.noTitle");
          const buttons = section.data?.buttonGroup?.buttons || [];
          return <MobileFooterSection key={section.id} title={sectionTitle} buttons={buttons} />;
        };
        $[111] = lang;
        $[112] = t;
        $[113] = t49;
      } else {
        t49 = $[113];
      }
      t48 = footerSections.map(t49);
      $[107] = footerSections;
      $[108] = lang;
      $[109] = t;
      $[110] = t48;
    } else {
      t48 = $[110];
    }
    let t49;
    if ($[114] !== t48) {
      t49 = <div className="divide-y divide-[#222] bg-black">{t48}</div>;
      $[114] = t48;
      $[115] = t49;
    } else {
      t49 = $[115];
    }
    let t50;
    let t51;
    if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
      t50 = <div className="mt-6 mb-2 flex justify-center"><LanguageSwitcherInFooter /></div>;
      t51 = <div className="text-footer-gray mb-2 text-center text-xs">©POP MART</div>;
      $[116] = t50;
      $[117] = t51;
    } else {
      t50 = $[116];
      t51 = $[117];
    }
    t5 = <footer className="text-footer-gray w-full bg-black px-4 pt-8 pb-4 text-sm">{t20}{t46}{t47}{t49}{t50}{t51}{paymentMethodsToShow.length > 0 && <div className="mt-4 mb-4 flex justify-center gap-2">{paymentMethodsToShow.map(_temp3)}</div>}</footer>;
    $[10] = email;
    $[11] = footerSections;
    $[12] = getEmailFromCustomer;
    $[13] = getPaymentMethods;
    $[14] = getServiceTime;
    $[15] = handleSubscribe;
    $[16] = lang;
    $[17] = socialMedia;
    $[18] = t;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}
function _temp3(card_0) {
  return <Image key={card_0.method} src={card_0.src} alt="paymentData" width={32} height={20} style={{
    width: "8.53vw",
    height: "5.33vw"
  }} unoptimized={true} />;
}